export default __webpack_public_path__ + "static/media/ELLE.dc95d3c8.jpg";